import {useMemo} from 'react'
import {BarChart} from './BarChart'
import {average} from 'simple-statistics'
import {Imoveis} from '../../types'

type Props = {
  label?: string
  itens: Imoveis[]
}

export default function PrecoMedioM2({label, itens}: Props) {
  let {chartDataVSOMetragem} = useMemo(() => {
    let precoMedioM2 = Array.from({length: 6}, (e) => [])
    let totalUnidades = Array(6).fill(0, 0, 6)

    let chartDataVSOMetragem = [
      {
        name: 'Preço M²',
        data: [],
      },
    ]
    // eslint-disable-next-line array-callback-return
    itens.map((item) => {
      let i = item.quartos > 5 ? 5 : item.quartos

      totalUnidades[i] = totalUnidades[i] + 1
      precoMedioM2[i].push(Number(item.aluguel_total) / Number(item.area))
    })
    // eslint-disable-next-line array-callback-return
    totalUnidades.map((item, key) => {
      chartDataVSOMetragem[0].data.push({
        x: key + ' Dorm.',
        y: precoMedioM2[key].length > 0 ? average(precoMedioM2[key]) : 0,
        total_unidades: item,
        id: key,
      })
    })
    return {chartDataVSOMetragem}

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itens])
  return (
    <>
      {/* <div className='col-6'> */}
      <BarChart
        data={chartDataVSOMetragem}
        className={''}
        title={'Preço médio de domitórios por m²'}
        subtitle={''}
        onChange={() => {}}
        legenda={['Preço médio m²']}
      ></BarChart>
      {/* </div>
      <div className='col-6'>Map</div> */}
    </>
  )
}
